import _get from 'lodash/get';

/**
 * Adds Lodash's "get" method for use in templates.
 *
 * @param {Object} params
 * @param {Vue} params.Vue
 */
export default async ({ Vue }) => {
  Vue.prototype.$_get = _get;
};
